<template>
  <div v-if="show" class="footer-bar">
    <div
      v-for="(item, i) in tabs"
      :key="i"
      class="footer-tab"
      :class="{ 'footer-tab--active': active === i }"
      @click="go(item)"
    >
      <!-- 激活时的高亮背景泡 -->
      <div class="tab-bubble" v-if="active === i"></div>

      <div class="tab-icon" v-html="item.icon"></div>
      <div class="tab-label">{{ $t(item.labelKey) }}</div>
    </div>
  </div>
</template>

<script>
function svgIcon(path, viewBox = '0 0 24 24') {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${viewBox}" fill="currentColor">${path}</svg>`;
}

const ICONS = {
  home:     svgIcon('<path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>'),
  comments: svgIcon('<path d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 14H6l-2 2V4h16v12z"/><path d="M7 9h10v2H7zm0-3h10v2H7zm0 6h7v2H7z"/>'),
  video:    svgIcon('<path d="M4 6H2v14a2 2 0 0 0 2 2h14v-2H4V6zm16-4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-8 12.5v-9l6 4.5-6 4.5z"/>'),
  choose:   svgIcon('<path d="M12 22q-.825-.825-1.6-1.563T8.875 18.9q-1.575-1.35-2.725-2.888T5 13q0-2.9 2.038-4.762T12 6.35q2.925.488 4.963 2.35T19 13q0 1.725-1.15 3.263T15.125 18.9q-.95.812-1.725 1.55T12 22Zm0-3.1q.375-.35.813-.725t.937-.825q1.35-1.15 2.3-2.362T17 13q0-2.075-1.463-3.413T12 8.25q-2.075.662-3.538 2T7 13q0 1.65.95 2.863t2.3 2.362q.5.45.938.825T12 18.9Zm0-3.15q1.05 0 1.775-.725T14.5 13.25q0-1.05-.725-1.775T12 10.75q-1.05 0-1.775.725T9.5 13.25q0 1.05.725 1.775T12 15.75ZM6.5 5.5q-.625-.35-1.263-.588T4 4.65V3q.85.05 1.675.338T7.25 4.15L6.5 5.5Zm9 0L14.75 4.15q.75-.475 1.575-.763T18 3v1.65q-.65.1-1.288.338T15.5 5.5ZM12 4q-.825 0-1.588.138T8.85 4.6L8.1 3.25Q8.975 2.9 9.9 2.7T12 2.5q1.075 0 2.1.2t1.8.75L15.15 4.6q-.575-.25-1.313-.425T12 4Z"/>'),
  lottery:  svgIcon('<path d="M21 6H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm-1 10H4V8h16v8zM8 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm0 3.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm8-3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm0 3.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-4-3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"/>'),
  mine:     svgIcon('<path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/>'),
};

export default {
  data() {
    return {
      show: false,
      active: 0,
      tabs: [
        { labelKey: 'foorter.index',    icon: ICONS.home,     route: '/Home'        },
        { labelKey: 'foorter.comments', icon: ICONS.comments, route: '/Comments'    },
        { labelKey: 'foorter.subscribe',icon: ICONS.video,    route: '/Video'       },
        { labelKey: 'foorter.xuanfei',  icon: ICONS.choose,   route: '/ChooseEntry' },
        { labelKey: 'foorter.video',    icon: ICONS.lottery,  route: '/Lottery'     },
        { labelKey: 'foorter.my',       icon: ICONS.mine,     route: '/Mine'        },
      ],
    };
  },
  methods: {
    go(item) {
      if (this.$route.path !== item.route) {
        this.$router.push(item.route);
      }
    },
    syncRoute(name) {
      const map = {
        home:        0,
        comments:    1,
        video:       2,
        chooseEntry: 3,
        choose:      3,
        Lottery:     4,
        mine:        5,
      };
      if (name in map) {
        this.active = map[name];
        this.show   = true;
      } else {
        this.show = false;
      }
    },
  },
  watch: {
    $route(to) { this.syncRoute(to.name); },
  },
  created() {
    this.syncRoute(this.$route.name);
  },
};
</script>

<style lang="less" scoped>
/* ===== 底部导航栏 ===== */
.footer-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 108px;
  background: #fff;
  display: flex;
  align-items: stretch;
  box-shadow: 0 -1px 0 rgba(0,0,0,0.06), 0 -4px 16px rgba(126,86,120,0.08);
  z-index: 999;
  padding-bottom: env(safe-area-inset-bottom);
}

/* 单个 tab */
.footer-tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  position: relative;
  cursor: pointer;
  color: #b0aab4;
  transition: color 0.25s ease;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}
.footer-tab--active {
  color: #c471a0;
}

/* 激活泡 */
.tab-bubble {
  position: absolute;
  top: 10px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(230,195,161,0.22), rgba(196,113,160,0.18));
  pointer-events: none;
  animation: bubble-in 0.25s cubic-bezier(0.34,1.56,0.64,1) both;
}
@keyframes bubble-in {
  from { transform: scale(0.4); opacity: 0; }
  to   { transform: scale(1);   opacity: 1; }
}

/* 图标 */
.tab-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  transition: transform 0.2s ease;
}
.footer-tab--active .tab-icon {
  transform: translateY(-2px);
}
.tab-icon svg {
  width: 44px;
  height: 44px;
}

/* 文字 */
.tab-label {
  font-size: 20px;
  line-height: 1;
  font-weight: 500;
  letter-spacing: 0.5px;
  position: relative;
  z-index: 1;
}
.footer-tab--active .tab-label {
  font-weight: 700;
  background: linear-gradient(135deg, #e6c3a1, #c471a0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
